import styled from 'styled-components';
import { ReactComponent as Notification } from '~/assets/images/notification-icon.svg';

const ChallengesContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: #ffffff;
`;

ChallengesContainer.Container = styled.div`
  width: 100%;
  background-color: #ffffff;
  @media (max-width: 770px) {
    height: 100%;
    overflow-y: hidden;
    padding: 0;
  }
`;

ChallengesContainer.Content = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #ffffff;
  @media (max-width: 770px) {
    width: 100%;
  }
`;

ChallengesContainer.NavigationContainer = styled.div`
  width: 100%;
  height: 100vh;
  padding: 0px 65px;
  overflow-y: scroll;

  @media (max-width: 1400px) {
    height: 100vh;
  }

  @media (max-width: 770px) {
    width: 100%;
    height: calc(100% - 185px);
    padding: 0px 5px 30px 5px;
    background-color: #ffffff;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    gap: 1rem;
  }

  @media (min-width: 770px) and (max-width: 1400px) {
    padding: 0px 40px 15px 10px;
    height: 100vh;
  }
`;

ChallengesContainer.Top = styled.div`
  background: #000FFF;
  width: 100%;
  padding: 10px 10px 0px 0px;
  * {
    margin: 0;
  }
`;

ChallengesContainer.TopWhite = styled.div`
  background: white;
  width: 100%;
  padding: 10px 10px 0px 0px;
  * {
    margin: 0;
  }
`;

ChallengesContainer.DiamondIcon = styled(Notification)`
  width: 40px;
  float: left;
  margin-right: 10px;
`;


ChallengesContainer.SectionChallenges = styled.div`
  background: #000FFF;
`;

ChallengesContainer.AreaTop = styled.div`
  padding: 2px;
  display: flex;
  flex-direction: row;
  heigth: 60%;
  justify-content: space-between;

  @media (max-width: 770px) {
    flex-direction: column;
  }
`

ChallengesContainer.AreaImageTitle = styled.div`
  padding: 90px 20px 90px 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;

  @media (max-width: 770px) {
    flex-direction: column;
  }
`

ChallengesContainer.AreaText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: left;
  padding: 20px;
`

ChallengesContainer.AreaImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 260px;
  max-height: 270px;
  padding-right: 20px;
`

ChallengesContainer.AreaTitle = styled.div`
  text-align: left;
  font: normal normal bold 28px/45px Roboto;
  letter-spacing: 0.82px;
  color: #FFFFFF;
  max-width: 530px;
`

ChallengesContainer.AreaSub = styled.div`
  margin-top: 5px;
  text-align: left;
  font: normal normal normal 18px/26px Roboto;
  letter-spacing: 0.48px;
  color: #FFFFFF;
  max-width: 530px;
`

ChallengesContainer.AreaHtml = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  
  img {
    max-width: 100%;
    height: auto;
  }
`

ChallengesContainer.AreaContent = styled.div`
  display: flex;
  text-align: left;
  min-width: 440px;
  justify-content: center;
  width: min-content;
  padding: 90px 50px 30px 50px;

  @media (min-width: 800px) {
    min-width: 540px;
  }
  @media (min-width: 1000px) {
    min-width: 740px;
  }
  @media (min-width: 1500px) {
    min-width: 940px;
  }
  @media (min-width: 1800px) {
    min-width: 940px;
  }
  @media (min-width: 2000px) {
    min-width: 1240px;
  }
`

export default ChallengesContainer;
